import React, { useEffect, useState } from "react";
import api from "../../services/api";

export default function InvestituresEglise() {
  const [investitures, setInvestitures] = useState([]);

  useEffect(() => {
    loadInvestitures();
  }, []);

  const loadInvestitures = () => {
    api.get("/investitures")
      .then(res => setInvestitures(res.data))
      .catch(err => {
        console.error("Erreur chargement investitures :", err);
      });
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="text-primary fw-bold mb-0">
          <i className="bi bi-award me-2"></i>🏅 Investitures
        </h4>
        <span className="badge bg-info text-dark">Total : {investitures.length}</span>
      </div>

      {investitures.length === 0 ? (
        <div className="alert alert-info shadow-sm">
          <i className="bi bi-info-circle me-2"></i>Aucune investiture trouvée.
        </div>
      ) : (
        <div className="row">
          {investitures.map((item) => (
            <div className="col-md-6 mb-4" key={item.id}>
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <h5 className="card-title text-primary">
                    <i className="bi bi-calendar-event me-2"></i>
                    {new Date(item.date).toLocaleDateString()}
                  </h5>
                  <p className="mb-2">
                    <strong>📍 Lieu :</strong> {item.location}
                  </p>
                  {item.notes && (
                    <p className="mb-3">
                      <strong>📝 Notes :</strong> {item.notes}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
} 